module.exports = __webpack_public_path__ + "media/images/wendys-inspiration-artwork-4fbfcdde1d977a47e832a240ba871250.png";